#import "./product-for-lead-fragment.graphql"

fragment ProductsForLeadFragment on Lead {
    id
    products(first: 1000) {
        edges {
            ...ProductForLeadFragment
        }
    }
}
